module.exports = __webpack_public_path__ + "fonts/Lato-Light.2bcc211c.ttf";